import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import HeaderNavigation from '../../components/Navigation/Header'
import Layout from 'antd/lib/layout'
import SideNavigation from '../../components/Navigation/Side'
import './Layout.css'

const { Content, Header, Sider } = Layout

const styles = {
    container: {
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
    },
    content: {
        margin: 0,
    },
    sider: {
        boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.5)',
        width: 286,
        zIndex: 999,
    },
    trigger: {
        top: 10,
        zIndex: 10,
    },
}

function GuardianLayout({ children }) {
    const client = useSelector((state) => state.app.client)

    return (
        <Layout style={styles.container}>
            <Sider
                breakpoint="lg"
                collapsedWidth="0"
                theme="light"
                collapsible={false}
                zeroWidthTriggerStyle={styles.trigger}
                style={styles.sider}
            >
                <SideNavigation />
            </Sider>
            <Layout>
                <Header
                    style={{
                        backgroundColor: `rgba(${client.color.r},${client.color.g},${client.color.b},1.0)`,
                        padding: '0',
                        zIndex: 1,
                    }}
                >
                    <HeaderNavigation />
                </Header>
                <Content style={styles.content}>{children}</Content>
            </Layout>
        </Layout>
    )
}

export default GuardianLayout
